var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.label == 1 ? _c('label', {
    staticClass: "d-block",
    staticStyle: {
      "color": "#ffffff !important",
      "font-size": "15px"
    }
  }, [_vm._v(" Qtd: ")]) : _vm._e(), _vm.label == 2 ? _c('label', {
    staticClass: "d-block",
    staticStyle: {
      "color": "#ffffff !important",
      "font-size": "15px"
    }
  }, [_vm._v(" Valor: ")]) : _vm._e(), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: _vm.options,
      expression: "options"
    }],
    staticClass: "form-control",
    class: _vm.inputClass,
    attrs: {
      "type": "tel",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "change": _vm.change,
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.hamdleOnEnter.apply(null, arguments);
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };